import { http } from 'lib_ui-services';
import { state, display, presentation, remember, syncAppearance, isCurrent } from './session';
export const _private = { http };
export default {
    verb: 'doingEdit',
    namespace: 'application',
    relation: 'readerSetup',
    description: 'Open the temporary reader setup form',
    logic: async ({ data, context }) => {
        const setup = state(context);
        if (context.formInstanceId) setup.formInstanceId = context.formInstanceId;
        if (!data.record && setup.id) {
            try {
                const snapshot = await _private.http.get(`${setup.base}/${setup.id}`);
                if (!isCurrent(setup)) return;
                setup.draft = display(setup.draft, snapshot);
                syncAppearance(setup);
            } catch (error) {
                if (!isCurrent(setup)) return;
                if (error.status === 404) {
                    setup.id = undefined;
                    setup.mqttLoginReady = false;
                    remember(setup);
                }
                setup.draft.requestStatus = error.message;
            }
        }
        return {
            record: presentation({ ...(data.record || setup.draft), busy: !!setup.pending, mqttLoginReady: !!setup.mqttLoginReady }),
            activationVerb: 'edit',
            namespace: context.namespace,
            relation: context.relation,
            isNew: false,
            // Automatic status updates must apply in order. Skipping change confirmation
            // prevents a pending progress update from discarding the final idle state.
            type: data.ignoreChanges ? 'ignore-changes' : 'singleRecordForm',
            ignoreChanges: data.ignoreChanges
        };
    }
};
